import React, { Component } from "react";
import { Card, Icon, Tag, Radio, Checkbox, Row, Col } from "antd";
import WizardFooter from "./wizard-footer";
import SecondaryHome from "./images/bfile-homeowners.svg";
import MFGHome from "./images/bfile-mfg.svg";
import Condominium from "./images/bfile-condominium.svg";
import Landlord from "./images/bfile-landlord.svg";
import VacantProperty from "./images/bfile-vacant-land.svg";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import ZillowSecondaryHomeValueContainer from "./zillow-secondary-home-value-container";

const RadioGroup = Radio.Group;

class Step extends Component {
  render() {
    const { wizard, updateField } = this.props;

    let secondary_home_type = [];
    if (wizard.secondary_home_type !== "") {
      secondary_home_type = JSON.parse(wizard.secondary_home_type);
    }

    const secondary_home_types = [
      {
        name: "Secondary Home",
        icon: SecondaryHome
      },
      {
        name: "MFG Home",
        icon: MFGHome
      },
      {
        name: "Condominium",
        icon: Condominium
      },
      {
        name: "Landlord",
        icon: Landlord
      },
      {
        name: "Vacant Property",
        icon: VacantProperty
      }
    ];

    return (
      <div>
        <Card
          className="wizardCard"
          bordered={false}
          title={
            <div>
              <Tag color="#87d068">
                <Translate text={wizard.status} />
              </Tag>
              <Translate text={`Secondary Properties`} />
            </div>
          }
        >
          <Card
            title={
              <Translate
                text={`"Do you own any additional properties outside your primary residence (e.g. rentals, 2nd home, condo, vacant land, etc.)?"`}
              />
            }
            className="wizardBox"
            type="inner"
            style={{ textAlign: "center" }}
          >
            <RadioGroup
              value={wizard.secondary_home_toggle}
              onChange={(e) =>
                updateField("secondary_home_toggle", e.target.value)
              }
            >
              <Radio value="1" className="btnYes">
                <Icon
                  type="like-o"
                  style={{ marginRight: 10, color: "#388E3C" }}
                />{" "}
                <Translate text={`Yes`} />
              </Radio>
              <Radio value="0" className="btnNo">
                <Icon
                  type="dislike-o"
                  style={{ marginRight: 10, color: "#FF3D00" }}
                />{" "}
                <Translate text={`No`} />
              </Radio>
            </RadioGroup>
          </Card>

          {wizard.secondary_home_toggle === "1" ? (
            <div>
              <Card
                title={<Translate text={`"Which kind?"`} />}
                type="inner"
                className="wizardBox"
                style={{ textAlign: "center" }}
              >
                <Checkbox.Group
                  className="radioIcons"
                  value={secondary_home_type}
                  style={{ width: "100%" }}
                  onChange={(checkedList) =>
                    updateField(
                      "secondary_home_type",
                      JSON.stringify(checkedList)
                    )
                  }
                >
                  <Row gutter={16}>
                    {secondary_home_types.map((item, i) => {
                      return (
                        <Col key={i} md={8} span={24}>
                          <Checkbox value={item.name}>
                            <div className="radioIconOption">
                              <div className="icon">
                                <img src={item.icon} alt={item.name} />
                              </div>
                              <div className="title">
                                <Translate text={item.name} />
                              </div>
                            </div>
                          </Checkbox>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>
              </Card>
              <ZillowSecondaryHomeValueContainer {...this.props} />
            </div>
          ) : null}

          <WizardPager
            updateField={updateField}
            stepIndexPages={[4, 5, 6, 7, 8]}
            wizardStepIndex={wizard.stepIndex}
          />
        </Card>
        <WizardFooter {...this.props} />
      </div>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step3_2.js